import { render, staticRenderFns } from "./AverageTimeReport.vue?vue&type=template&id=69b1f815&scoped=true"
import script from "./AverageTimeReport.ts?vue&type=script&lang=ts&external"
export * from "./AverageTimeReport.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b1f815",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69b1f815')) {
      api.createRecord('69b1f815', component.options)
    } else {
      api.reload('69b1f815', component.options)
    }
    module.hot.accept("./AverageTimeReport.vue?vue&type=template&id=69b1f815&scoped=true", function () {
      api.rerender('69b1f815', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/components/reports/AverageTimeReport/AverageTimeReport.vue"
export default component.exports